import {
  HumanServiceWrapper,
  StyledSpace,
  ServiceTitle,
  ServiceText,
  BadgeWrapper,
} from "./atom";
import { Space } from "task-eva-ui";
import ServiceArrowIcon from "./icons/service-arrow";
import ServiceConsultIcon from "./icons/service-consult";
import ServiceConsultFoxIcon from "./icons/service-consult-fox";
import WebConsultationIcon from "./icons/web-consultation";
import { getTranslateNsT } from "./i18n";
import { IHumanService } from "./type";
import { isEn } from "project-config/utils/env";
import { saleSmartlyInstance } from "project-config/services";
import { useMemo } from "react";

export function HumanService({
  salesmanEmail,
  salesmanPhone,
  salesmanName,
  isPictureUser,
  isDomestic,
  unRead = 0,
}: IHumanService) {
  const t = getTranslateNsT(isEn() ? "en" : "zh");
  const contact = !isDomestic ? salesmanEmail : salesmanPhone;
  const showContact = !isPictureUser && (salesmanName || contact);
  const unReadText = useMemo(() => (unRead >= 100 ? "99+" : unRead), [unRead]);

  return (
    <HumanServiceWrapper isFox={!isDomestic}>
      {!isDomestic && (
        <StyledSpace height="44px">
          <div
            className="service-item"
            onClick={() => void saleSmartlyInstance.openChatWindow()}
          >
            <Space gap={4}>
              <div className="message-icon">
                <WebConsultationIcon />
                {unRead > 0 && <BadgeWrapper>{unReadText}</BadgeWrapper>}
              </div>
              <span>Web consultation</span>
            </Space>
            <ServiceArrowIcon />
          </div>
        </StyledSpace>
      )}
      <StyledSpace height="44px">
        <a
          href={
            isDomestic
              ? `https://wpa1.qq.com/ujoglPGq?_type=wpa&qidian=true`
              : `https://api.whatsapp.com/send/?phone=8618124758259&text=Hello.May%20i%20help%20you?`
          }
          target="_blank"
        >
          <Space gap={4} center>
            {!isDomestic ? <ServiceConsultFoxIcon /> : <ServiceConsultIcon />}
            <span>
              {t(!isDomestic ? "service_consult_fox" : "service_consult")}
            </span>
          </Space>
          <ServiceArrowIcon />
        </a>
      </StyledSpace>
      <StyledSpace direction="column" gap={2}>
        <ServiceTitle>
          {t(!isDomestic ? "service_email" : "service_24_hour")}
        </ServiceTitle>
        <ServiceText>
          {t(!isDomestic ? "service_contact_email" : "service_contact")}
        </ServiceText>
      </StyledSpace>
      {showContact && (
        <StyledSpace direction="column" gap={2}>
          <ServiceTitle>{t("private_manager")}</ServiceTitle>
          <ServiceText>{salesmanName || ""}</ServiceText>
          <ServiceText>{contact || ""}</ServiceText>
        </StyledSpace>
      )}
    </HumanServiceWrapper>
  );
}
